import { render, staticRenderFns } from "./discharge.vue?vue&type=template&id=c0b6a1b8&scoped=true&"
import script from "./discharge.vue?vue&type=script&lang=js&"
export * from "./discharge.vue?vue&type=script&lang=js&"
import style0 from "./discharge.vue?vue&type=style&index=0&id=c0b6a1b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b6a1b8",
  null
  
)

export default component.exports